var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSalePriceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.65878 3.76463V7.63511H4.87048V3.76463H6.52926L3.76463 1L1 3.76463H2.65878Z",
    stroke: "#6856DB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1409 5.1085V9.84155C18.1409 10.201 17.9971 10.5438 17.7483 10.7926L9.69216 18.8487C9.16688 19.374 8.31537 19.374 7.79009 18.8487L3.05705 14.1157C2.53177 13.5904 2.53177 12.7389 3.05705 12.2136L11.1132 4.15747C11.3675 3.90312 11.7103 3.76489 12.0642 3.76489H16.7973C17.5382 3.76489 18.1409 4.36758 18.1409 5.1085Z",
    stroke: "#6856DB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0987 7.08222C15.2514 7.08222 15.3752 6.95845 15.3752 6.80576C15.3752 6.65307 15.2514 6.5293 15.0987 6.5293C14.946 6.5293 14.8223 6.65307 14.8223 6.80576C14.8223 6.95845 14.946 7.08222 15.0987 7.08222Z",
    stroke: "#6856DB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalePriceIcon);
export default __webpack_public_path__ + "static/media/SalePriceIcon.d02a51b3263d9f07a18d1c199bbac7db.svg";
export { ForwardRef as ReactComponent };